import { FileText } from "lucide-react";
import { ImportComingSoon } from "./ImportComingSoon";

export function ImportClinicalRecordsSection() {
  return (
    <ImportComingSoon
      icon={<FileText className="h-6 w-6" />}
      title="Importar fichas clínicas"
      description="Importe anamneses, prontuários e observações clínicas vinculadas aos pacientes."
      features={[
        "Upload drag-and-drop (.csv, .xlsx, .xls — até 50MB)",
        "Vincula automaticamente à ficha do paciente por CPF ou nome",
        "Campos: histórico médico, alergias, medicações, observações, data da anamnese",
        "Preserva texto livre com formatação básica",
        "Estratégia: mesclar com existente, substituir ou adicionar ao final",
        "Preview antes de importar",
        "Relatório: fichas importadas, pacientes não encontrados, erros",
      ]}
    />
  );
}
